var _path, _path2, _g, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _circle, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHomeImage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 300,
    height: 300,
    viewBox: "0 0 300 300",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M150 300C232.843 300 300 232.843 300 150C300 67.1573 232.843 0 150 0C67.1573 0 0 67.1573 0 150C0 232.843 67.1573 300 150 300Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_825_4173",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 300,
    height: 300
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M150 300C232.843 300 300 232.843 300 150C300 67.1573 232.843 0 150 0C67.1573 0 0 67.1573 0 150C0 232.843 67.1573 300 150 300Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_825_4173)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M236 86H64C58.4772 86 54 90.4772 54 96V306C54 311.523 58.4772 316 64 316H236C241.523 316 246 311.523 246 306V96C246 90.4772 241.523 86 236 86Z",
    fill: "#F6FAFD"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 74,
    y: 110,
    width: 120,
    height: 18,
    rx: 9,
    fill: "#DFEAFB"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 74,
    y: 164,
    width: 58,
    height: 18,
    rx: 9,
    fill: "#4EB0C2"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 74,
    y: 218,
    width: 92,
    height: 18,
    rx: 9,
    fill: "#DFEAFB"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 74,
    y: 268,
    width: 94,
    height: 18,
    rx: 9,
    fill: "#DFEAFB"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 170,
    y: 218,
    width: 22,
    height: 18,
    rx: 9,
    fill: "#DFEAFB"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 136,
    y: 164,
    width: 70,
    height: 18,
    rx: 9,
    fill: "#4EB0C2"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 170.5,
    cy: 182.5,
    r: 11.5,
    fill: "#F6FAFD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M192.413 200.999C192.598 201.185 192.746 201.405 192.846 201.648C192.947 201.89 192.999 202.151 192.999 202.413C192.999 202.676 192.947 202.936 192.846 203.179C192.746 203.421 192.598 203.642 192.413 203.828L191.828 204.413C191.642 204.598 191.421 204.746 191.179 204.846C190.936 204.947 190.676 204.999 190.413 204.999C190.151 204.999 189.89 204.947 189.648 204.846C189.405 204.746 189.185 204.598 188.999 204.413L182.093 197.508L179.358 203.8C179.204 204.157 178.95 204.461 178.625 204.674C178.3 204.887 177.92 205 177.531 204.999H177.434C177.029 204.982 176.639 204.841 176.317 204.595C175.995 204.349 175.756 204.01 175.633 203.624L169.099 183.614C168.984 183.264 168.969 182.889 169.055 182.53C169.14 182.172 169.323 181.844 169.584 181.584C169.844 181.323 170.172 181.14 170.53 181.055C170.889 180.969 171.264 180.984 171.614 181.099L191.624 187.633C192.006 187.761 192.341 188.001 192.584 188.323C192.828 188.644 192.968 189.032 192.987 189.435C193.006 189.838 192.903 190.237 192.691 190.58C192.479 190.923 192.169 191.194 191.8 191.358L185.508 194.093L192.413 200.999Z",
    fill: "#4EB0C2"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeImage);
export default __webpack_public_path__ + "static/media/home-image.66f5113d0fa41fa062733044e27afeac.svg";
export { ForwardRef as ReactComponent };